module.exports = __webpack_public_path__ + "images/emoji/ship.64c512bd696e3df3e026.png";